"use client"

import {useEffect, useState} from 'react';
import {Place as PlaceType} from "@/types/Places";
import {placeRequest} from "@/utils/api/Place";

const useSegmentData = (placeId: string) => {
  const [data, setData] = useState<PlaceType | undefined>(undefined);

  useEffect(() => {
    const fetchData = async () => {
      const fetched = await placeRequest(placeId)
      if (fetched) {
        setData(fetched);
      }
    }
    if (!data) {
      fetchData();
    }
  }, [data, placeId]);

  return data;
};

export default useSegmentData;
